export const aNamed3 = "a-named3";



// WEBPACK FOOTER //
// ./src/mod10.js